import type { ApprovalChain } from '../approval-chain.model';

export const DEED_CONSOLIDATION_CHAIN: ApprovalChain = {
  id: 'deed-consolidation',
  label: 'Consolidation',
  applicationTypes: ['DEED_CONSOLIDATION'],
  steps: [
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['SUBMITTED', 'RESUBMITTED'], to: 'FINANCE_APPROVED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Verify', from: ['EXAMINER_RECOMMENDED'], to: 'REGISTRAR_VERIFIED' },
  ],
};
